import { authService } from "./authServices";

const courseService = authService.injectEndpoints({
    reducerPath: 'courseService',
    endpoints: (builder) => {
        return {
            createCourse: builder.mutation({
                query: (data) => {
                    return {
                        url: '/course/create-course',
                        method: 'POST',
                        body: data
                    };
                },
                invalidatesTags: ['USER']
            }),
            commentCourse: builder.mutation({
                query: (data) => {
                    return {
                        url: '/course/comment-course',
                        method: 'POST',
                        body: data
                    };
                },
                invalidatesTags: ['USER']
            }),
            buyCourse: builder.mutation({
                query: (data) => {
                    return {
                        url: '/course/buy-course',
                        method: 'POST',
                        body: data
                    };
                },
                invalidatesTags: ['USER']
            }),
            getAllCourse: builder.query({
                query: () => {
                    return {
                        url: `/course/get-all-courses`,
                    };
                },
                providesTags: ['USER']
            }),
            getAuthorCourse: builder.query({
                query: (id) => {
                    return {
                        url: `/course/get-author-courses/${id}`
                    };
                }
            }),
            getDetailCourse: builder.query({
                query: (id) => {
                    return {
                        url: `/course/get-detail-course/${id}`,
                    };
                },
                providesTags: ['USER']
            }),

        };
    }
});

export const { useCreateCourseMutation, useGetDetailCourseQuery, useGetAuthorCourseQuery, useBuyCourseMutation, useGetAllCourseQuery, useCommentCourseMutation } = courseService;

export default courseService;